import React from "react";
import FormInput from "../components/FormInput";

const BankingInformationSection = ({
  formValues,
  onChangeInput,
  formErrors,
  assignRef,
  isReOnboard
}) => {
  return (
    <div className="staff-onboarding-form-section">
      <div className="staff-onboarding-section-header">
        <h3 className="staff-onboarding-section-title">Banking Information</h3>
        <p className="staff-onboarding-section-subtitle">Bank account details for salary payments</p>
      </div>
      <div className="staff-onboarding-section-content">
        <div className="staff-onboarding-form-grid">
          <FormInput
            label="Bank Name"
            name="bankName"
            placeholder="Enter bank name"
            value={formValues.bankName}
            onChange={onChangeInput}
            error={formErrors?.bankName}
            disabled={isReOnboard}
            required={false}
            onRef={assignRef("bankName")}
          />

          <FormInput
            label="Account Number"
            name="accountNumber"
            placeholder="Enter account number"
            value={formValues.accountNumber}
            onChange={onChangeInput}
            error={formErrors?.accountNumber}
            disabled={isReOnboard}
            required={false}
            onRef={assignRef("accountNumber")}
          />

          <FormInput
            label="IFSC Code"
            name="ifscCode"
            placeholder="Enter IFSC code"
            value={formValues.ifscCode}
            onChange={onChangeInput}
            error={formErrors?.ifscCode}
            disabled={isReOnboard}
            required={false}
            onRef={assignRef("ifscCode")}
          />

          <FormInput
            label="UPI ID"
            name="upiID"
            placeholder="Enter UPI ID (optional)"
            value={formValues.upiID}
            onChange={onChangeInput}
            error={formErrors?.upiID}
            disabled={isReOnboard}
            onRef={assignRef("upiID")}
          />
        </div>
      </div>
    </div>
  );
};

export default BankingInformationSection;
